module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Sister’s Choice")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9781460302989.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("L")])]), _vm._v("ittle lives were not always shaped by big decisions, by moves across country or physical upheavals. More often, the lives of children were shaped by the small decisions, the mundane interactions, the patience required just to avoid leaving footprints on a little girl’s soul. That was when the true mettle of motherhood was tested. Jamie had told herself that from the moment she had become a parent. And from that very moment, she’d learned that following her own good advice wasn’t always going to be easy.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two adult-free days later, two days of hormones that made her skin crawl and her breasts ache, Jamie summoned a new shot of serenity as she listened to yet another in the barrage of Hannah’s questions.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Our stuff comes today? You’re sure? Manny and Warren can find us?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Busy trying to tame her youngest daughter’s mop of curls, Jamie glanced up and forced herself to wink at her oldest. “I dropped a trail of bread crumbs. Don’t you remember? And they promised they’d follow it here.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you dropped bread crumbs, the birds ate them. We have lived here almost forever.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two days, Hannah, and the guys just left Michigan yesterday. I promise they’ll find us.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie gently nudged Alison back into a sitting position, grabbed one last lock of hair and teased out the tangles with a wide-toothed comb. Alison, with her pink cheeks, green eyes and copper-colored hair, looked as if she’d just arrived as an exchange child from the Emerald Isle. Her father, Seamus Callahan, had bequeathed her everything except the curls. Those had come from Jamie’s father, Jimmy, an inheritance that Alison shared with her aunt Kendra. Jamie wondered if Kendra’s baby—if there was a baby—would emerge, as Alison had, with curls already plastered to its tiny head.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wish we had a big truck.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie tried to envision a real moving van creeping up their gravel driveway instead of the Ford Econoline with the two college students she’d hired to bring their personal belongings. “We’ll have a big van when we settle somewhere and they bring all our furniture.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you promise they will have our clothes and toys?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I promise. I promise!” Jamie released her hold on Alison, who sprang to her feet and tackled her sister. Hannah, who was habitually braced for this event, caught her and pushed her back toward her mother.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison had been as patient as she could manage. “I want to go outside!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie nabbed her youngest daughter for a big hug. “We can do that. But it’s sunny today. You have to wear a hat.” She looked up. “Both of you.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah rolled her eyes, but retreated to the pegs beside the back door, where hats and raincoats were hung. Alison followed at a gallop.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie waited where she was. The pegs were child-height. In fact, everything in the cabin had been planned with children in mind. The bedroom closet was sectioned so the girls could hang their clothes on the bottom rack and store more in cubbyholes on the side. The room had shelves along two walls, wide enough for toys and low and strong enough to perch on for play. The state-of-the-art bunk beds had a dresser and two cubbyholes for night treasures. On the porch, two rocking chairs scaled to a child’s shorter legs held special places.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie wasn’t surprised at Kendra’s attention to detail. The cabin was tiny, but Kendra had treated that as an asset. She had scaled down, carefully choosing just the right pieces to make the cabin feel like home. From the Egyptian cotton sheets to the All-Clad cookware, no effort had been spared to make staying there comfortable and easy. In the days since their arrival, Jamie hadn’t needed one thing that Kendra hadn’t provided.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The cabin itself was extraordinary. Jamie had designed it as a class project oriented toward using readily available materials and fixtures that were commonly stocked at lumberyards and big-box stores. In theory, the design was geared toward do-it-yourselfers planning to put up their own vacation nest.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rosslyn and Rosslyn, Kendra’s builders, had taken her basic plans to an entirely different level. Quality materials and workmanship had been the rule here. The natural cherry cabinets had custom detailing; the counters were desert-sand granite. The lone bathroom, though small, had an etched glass shower surround and slate tile. She was particularly fond of the copper sink mounted on a handcrafted iron pedestal.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was sorry that she hadn’t been able to participate in the construction of the cabin, but there wasn’t much she would have done differently. Kendra and the Rosslyns had made the cabin their own with subtle modifications and creativity. In the big picture, that meant Jamie’s plans were adaptable and therefore a success. Photos of the cabin, along with the blueprints, would take priority in her portfolio.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Someday—which seemed like a long stretch into the future at that moment—she really "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("would")]), _vm._v(" need a bigger and better portfolio. She would hang on to that thought in the months to come.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The girls screeched to a halt in front of her. All morning, she had promised a walk to the old orchard at the edge of the property, and she knew if they waited much longer, they would end up dragging themselves home, moping and sweaty. Since she was counting on the walk to tire them out, not transform them into heat zombies, the time had come.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, let’s scoot,” she told them. “Let’s see who can spot the first bluebird.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Outside, she drew in a deep breath and almost tasted the humidity. Maybe June had just established a foothold, but no matter what the calendar said, summer had arrived. Despite the heat, the excess of hormones and her unusually short supply of patience, the morning seemed almost idyllic, a long breath expelled after years of combining school, work and parenting.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie was not by nature a worrier. She was sure she had done the right thing by volunteering to carry a child for her sister and by bringing the girls to Virginia. She had her whole life ahead of her, years in which she could do exactly what she wanted to. Nine months was not a long time in the scheme of things. The time at the cabin would be a transition, a chance to take stock, to look over possibilities and make the best choices for their future.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the reality of what was in store was already beginning to set in. She adored her daughters, would walk barefoot up an erupting volcano for them, would swim the length of the Shenandoah. But the uninterrupted stretch of time alone with them, the confines of the cabin, a community where she and the girls were complete strangers? She just hoped that in addition to her daughters’ eccentric, charming companionship, she could find an accepting adult or two to converse with from time to time. Over the next year, she and the girls were going to need all the friends they could muster.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The girls took off for the orchard willingly enough, watching for flashes of blue along the route.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to run!” Alison ran ahead, and Hannah allowed her a head start, then took off after her. Jamie followed behind, hauling a mesh bag with a Frisbee, bottled water, a picnic blanket, granola bars and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Marvelous Land of Oz,")]), _vm._v(" which she was reading out loud.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The trip to the apple orchard was short. The small orchard might once have been productive enough to help feed Leah Spurlock Jackson, Isaac’s grandmother, and his mother, Rachel. Now, however, the trees were in the final stages of decline. Some had died with their roots still planted in the earth; others had fallen. Here and there, a carpet of dried blossoms indicated that some had struggled to bloom in May, but Jamie saw no indication of fruit. Her knowledge of gardening was limited to a philodendron that the girls had watered to death, but she wondered if any of the old trees could be saved.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She spread a blanket on the grass, then took out the Frisbee, but the girls wanted to explore.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will collect flowers,” Hannah announced. “There are enough to share with the animals who live here.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure the squirrels and chipmunks will approve.” Knowing where the flowers would go for the return trip, Jamie opened her water bottle and drank a couple of slugs to prepare.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you think Black Beauty left when the cabin burned down?” Hannah asked.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie remembered Black Beauty well, but she was impressed her daughter did, too. He—or possibly she—was a gargantuan black rat snake who had lived under the old cabin and nearly scared Jamie to death the first time he’d showed himself. The girls, on the other hand, had been fascinated.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aunt Kendra said she saw him slither off into the woods right before the fire,” Jamie assured her. “So he’s safe somewhere, and probably two feet longer by now.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you think he will come to live under our cabin?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie wondered how fast she could pack if he did.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They meandered, stopping every two feet to look at something, discussing snakes and squirrels and the kinds of birds that lived nearby. Alison and Hannah spotted the same bluebird at the same moment, a perfect end to the contest, then followed it deeper into the woods. As they went, the girls collected rocks and oddly shaped twigs, trading them back and forth like legitimate currency.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I bet the woodpeckers love the old apple trees,” Jamie said. “Bugs like to live under the bark, and woodpeckers like to eat bugs.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I invented the world, I would not let one animal eat another,” Hannah said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How about flies and mosquitoes?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would not invent flies and mosquitoes.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t like mosquitoes,” Alison said, siding with her sister. “I like spiders.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would not invent spiders, either,” Hannah told her.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d be sad.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were just about to turn around and head back for the blanket when Alison stopped. She pointed just beyond them, where the woods parted and eventually opened up to Fitch Crossing Road.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see something!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They hadn’t walked far, but even in the woods, the air was warm and humid. Already tired, Jamie was ready to finish her water and collapse for a while. She had been warned not to interpret unusual symptoms as in vitro success, but she remembered feeling exactly this way when she was pregnant with both girls.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s always something to see,” she said, resting her hand on her daughter’s back. “But let’s head to the blanket, okay?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison resisted. “It moved!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe it was a squirrel. There are lots of them around here.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bigger.” Alison spread her hands. Then, before Jamie could stop her, she plunged deeper into the woods, not in the direction Jamie wanted to go.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come back, Alison.” Jamie knew better than to depend on instant obedience. With thoughts of Black Beauty or worse, she took after her daughter to corral her.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison stopped abruptly. “See?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie nearly tripped over Alison’s compact body. Without thinking, she put an arm out to hold Hannah back and snatched Alison with the other to keep her from going any closer.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the sight that greeted all of them was nothing to be afraid of. Not far from their feet was a fawn, curled up in a ball. Its coloring was perfect camouflage, and if it had been moving before, now it was as still as a log. Jamie wondered how her youngest daughter had spotted it.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, Mommy.” Hannah tried to move forward, but Jamie held her back. “But it’s all alone.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure its mommy is nearby,” Jamie said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How do you know?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“See how perfectly it blends into the ground and the leaves? I bet its mommy left it here while she went off to find food. We have to go.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But how do you know for sure?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mommy animals know how to raise their young. If we move the baby, or maybe even if we touch it, the mommy will be afraid to come and take care of it. And it could die.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But what if the mommy is gone? Then it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")]), _vm._v(" die.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie pressed her lips together before she said something she regretted. She knew this was an argument she couldn’t win. Her oldest daughter would not forget about the fawn. Hannah would worry and fret until she was sure the little deer was safe.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here’s what we’ll do. I’ll hang my hat on this tree.” She took off the Detroit Tigers baseball cap she’d worn to shield her face from the sun and hung it on the branch of a nearby sapling. “Then we’ll come back in the morning and check. How’s that?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I want to check sooner.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That won’t give the mommy enough time to know it’s safe to move the baby. She’ll be afraid we’ll come back.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It might be sad all night, and crying.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think it will be sadder if we interfere and scare off its mommy.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah squatted. “Are you sad?” she asked the fawn. “Do you need help?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hannah! The poor little thing is hoping you don’t see it. Let’s get out of here and let the mommy come back.” Jamie urged Hannah up with a hand on her back.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I saw it,” Alison said. “Me!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, you did. What wonderfully sharp eyes you have. I’m very proud of you.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison beamed.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie managed to drag them away, but not until they had stopped for half a dozen peeks until they were too far from the fawn to see it anymore. Once they were out of sight, she knew their imaginations would set to work. The fawn would never be out of their minds.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thirty minutes later, after snacks and wildflower selection, they were finally resting on the blanket when the rumble of an engine sounded from the direction of the cabin. Jamie hoped the movers had arrived although, knowing how much college students liked to sleep in, she had expected them much later in the afternoon.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pushed herself to a sitting position. Hannah had been telling a story based on cloud shapes, but she had run out of steam and was recycling the plot. No surprise, the clouds had yielded a herd of deer and a mean wolf who wanted to eat them, until a little girl saved them.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Somebody’s here,” Jamie said, hoping whoever it was might help the girls forget the fawn, at least temporarily. “Are you girls ready to go back?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison bolted upright. “Lunch!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie got to her feet and offered her oldest daughter a hand. “Let’s see who’s here, then we can eat.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they packed up and started down the hill toward the cabin, the girls argued about what kind of sandwich they preferred. Jamie had found a natural-foods market in Woodstock and a farm stand on the outskirts. She was looking forward to buying fresh produce, and cooking for Kendra and Isaac when they came to visit. Since it was a passion and something she could do at the cabin, she suspected she would be cooking a lot in the next months.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We ought to plant some tomatoes,” Jamie said as they neared the clearing. “And maybe some peppers. We can learn how. I don’t think it’s too late in the season. Aunt Kendra said there’s space in the beds near the old cabin site.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I want to grow M&M’s.” Alison shoved Hannah when she laughed. “I do! Stop it!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie started to scoop up her youngest daughter, then she remembered that the doctor had warned her against lifting anything heavy while she waited to see if the in vitro was successful. Instead she pulled Alison close and admonished her softly.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can’t grow M&M’s in any garden,” she explained after she’d delivered a mini-lecture on shoving. “They make them in factories. But I’ll tell you what. If you help me plant tomatoes, I’ll buy you a pack of M&M’s. How’s that?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t like it when Hannah laughs.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s a good thing to make people smile, isn’t it? Better than making them cry.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" want to cry.” Alison puckered up but was unsuccessful.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would like an older sister,” Hannah said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eyes narrowed, Jamie sent her a warning glance.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As well as Alison,” Hannah said, shaking her head. “An older sister for both of us.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nice save,” Jamie said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They made the rest of the trip in silence, which was a relief. By the time they drew near enough to see a pickup parked outside their front door, Alison had forgotten she was angry.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not the movers.” The truck looked vaguely familiar, and a man in a T-shirt and khaki shorts was unloading plywood. After a few seconds, Jamie realized who it was.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That looks like Mr. Rosslyn. Cash. Remember Cash, Hannah? He fixed the stairs on the old cabin when we were here.” She glanced at Hannah. “You liked him. He’s a nice guy.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s he doing?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll find out.” Jamie called to him as they rounded the last bend. “Cash, up here.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man stopped and turned, watching as they drew closer. He didn’t wave, then go back to work, as most would have. He watched them approach. Jamie saw a slow grin light his face.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Boy, have they grown,” he said when the three females reached him.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie was delighted he remembered her daughters so well that he could catalog the changes. “Hey, it’s nice to see you again. I was hoping you’d come by this week, so I could tell you how much I love the cabin.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had good plans to work with.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope you’ll say the same thing about the big house. I’ve been working on incorporating Kendra and Isaac’s ideas with my own. Maybe you’ll have a chance to look over my final drawings soon, so we can have your architect go over them and draft the blueprints? Kendra says you’d like to break ground in a month or so.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be glad to. It was a darned shame about that fire. I’m glad they’re planning to get started again.” He squatted and looked Alison in the eye. “You’re Alison. I’m Cash. Remember?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We found a baby deer.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You did?” He sounded properly enthused. “Did it run away?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, it was little.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like you?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No! Little, like this.” She threw her arms open. “With spots.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why are you throwing boards on the ground?” Hannah asked.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re Hannah, right? Somebody told me two little girls needed a playhouse. Do you think they were right?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison whirled. “Mommy?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kendra sent you?” Jamie asked.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We both figured they’d need something to do out here this summer or go crazy as trout in a drought. A place of their own. And a way to give you a little more space.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie wondered how "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("much")]), _vm._v(" Kendra had told Cash about their reason for moving here. “I think it’s a wonderful idea. Girls, what do you say?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah spoke first. “How big is it going to be, and where do you plan to put it?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash got to his feet. “You’re Hannah, all right, only bigger. I remember all those questions.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was hoping for a thank you, not an interrogation,” Jamie told her daughter.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would like to know exactly what to thank him for.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash laughed. “Well now, I thought with your mommy’s help we could figure out something together. What do you think? Would you have some ideas?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah’s whole face glowed with excitement. “A pirate ship?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Too many showings of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Pan")]), _vm._v(",” Jamie explained.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or maybe a spaceship?” Hannah added")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lost in Space")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek")]), _vm._v(". Why don’t we let Mr. Rosslyn build you something that can be anything you want it to be. A castle, a ship, a fort.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash gave a low whistle. “You don’t ask for much, do you?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie met his eyes and smiled a little. Cash was an attractive man, and she was aware he was thinking of more than a playhouse. She felt his interest and saw it in his eyes. She reminded herself that she was feeling lonely, that she’d been yearning for an adult to talk to and was therefore a tad too receptive to the warmth in his smile. But despite her better instincts, she heard herself playing along.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, you might be surprised what I could ask for.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hesitated just long enough to make a point. “A man could have trouble keeping up.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She doubted this man would have trouble on any level. She studied him for a moment. Cash was taller than she was, although an inch or so shy of six feet. His hair was a warm brown, his skin deeply tanned. His eyes were most arresting of all, neither blue nor green but something in between, like a tropical ocean under dark brows and lashes. She guessed Cash was maybe four or five years older than she was, but like her, he had lived those years at warp speed. He was country-boy casual on the outside, but from the first time they’d met, she had thought there was probably something more simmering inside.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was thinking imagination ought to be the key component,” she said, pulling herself back to the matter at hand. “The girls can supply that.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now that’s funny, because that’s exactly what I had in mind. A deck with a sandbox under it? Slanted railings at the sides, a roof, maybe a slide for Alison, and a knotted rope to climb up and down for Hannah. A good pirate would have a rope.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But no plank to walk, okay? Alison would take that challenge in a heartbeat.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can see that. She looks like a pirate to me.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison beamed. “Cap’ain Hook!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Definitely a resemblance,” Cash said, nodding. “I thought maybe you girls might like to help me figure out just what to do, then put in a nail or two when the time comes. Would you be willing?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie could see that lunch had been temporarily forgotten. The girls were thrilled. For however long this took, they had a project to occupy them. Then, hopefully, the playhouse itself would be good for many happy hours.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This sounds like a lot of work to me,” she warned. “If you ask for their input, you might end up building a McMansion.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, I’ll take my chances.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It all sounds great, but we’ll owe you big-time for this.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your sister’s footing this bill.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt a surge of affection for Kendra, who had thought so far ahead and seen the need. “Listen, money can’t buy the peace the pair of you’ll be giving me.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The fawn wasn’t moving,” Hannah said, as if they had never changed the subject. “Do you know about fawns?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cash squatted down so they were eye to eye. “Yes, ma’am. I know that’s how they protect themselves. Where did you see it?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie listened as Hannah tried to explain. Once her daughter had finished, she clarified. “Where the woods curl back toward Fitch Crossing.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t moving. I think it will die,” Hannah said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I tell you what. I think we should check on it tomorrow morning. Just to be sure. I’ll come over, and we can go together, but we shouldn’t go back any sooner.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie was glad to have reinforcements. “I marked the place with a baseball cap.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He got to his feet. “Girls, I left something on the porch. My grandmother sent you a pie.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the moment the deer was forgotten. Hannah’s expression brightened, and Alison clapped her hands; then they took off together to see.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is all very nice of you,” Jamie told him.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No trouble. That’s how we welcome people in the country. By fattening them up.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was afraid the whole day was going to be about the fawn. Now they’ll spend at least some of it drawing up plans for the playhouse.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And eating apple pie.” His face grew serious. “I didn’t want to alarm them, but I did see a dead doe up on Fitch Crossing not too far from where you’re describing. I’ll call one of my men to help me remove it on the way out of here, so the girls don’t see it next time you leave, but we probably should keep an eye on that baby. Just in case that was the mother.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not hunters…”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not this time of year. No, a car. People aren’t always good about cleaning up their own messes.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And what should I do if that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" the mother and the baby’s alone?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s why I volunteered to come with you. We’ll see if we can figure out what’s up.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re going down in my book as a helpful guy to know.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d say just going down in your book is a good thing.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite the silent voice urging caution, she was enjoying herself. Talking to a man was a welcome change from the girls. Flirting with one was a welcome change from just being somebody’s mother. And she liked Cash, had liked him the first time they met. Had even thought about him a time or two since.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you were serious about stopping by in the morning?” she asked.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is just my first load of materials. Maybe the girls can come up with an idea or two for the playhouse between now and then. We’ll look for the fawn first, then see what we can do about starting on it.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll show you what I’ve done on the house plans, and by then the girls will have thought of a hundred good ideas to share with—” She came to an abrupt halt. “I’m sorry. I’m assuming you’re still single and don’t have a wife who has the right to claim your Sundays. I wasn’t thinking.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How did you know I was single in the first place?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, last time I was here, it came up in some conversation or other.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry I didn’t get to hear that one.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were back to flirting. Worse, she was back to liking it. “I doubt it was anywhere near as interesting as you’re imagining.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not married. No woman in her right mind wants to be saddled with me, and of course this is strictly business, right?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She thought of the baby that could well be growing inside her. “Oh, yeah. That’s definitely what it is.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison gave a whoop, and Jamie turned to see Hannah holding up the pie. “I’d better go. I promised the girls some lunch. I’d be happy to feed you, too.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, but I ate. I’m going to unload this truck, then head out. But I’ll bring another load when I come back tomorrow.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll thank your grandmother for me?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll tell her.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie started toward the cabin, then she glanced over her shoulder. He was watching her, but she had known that. She’d almost felt his gaze. “See you then, and thanks again for everything.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It will be my pleasure.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jamie was just a little worried about the pleasure "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" felt.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60225cdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781460302989_ch02.vue
// module id = 81
// module chunks = 0